export type IAutoFill = IAutoFillFromValue | IAutoFillFromQueryParam | IAutoFillFromCookie

interface IAutoFillFromValue {
  type: 'value'
  value: string
}

export function isAutoFillFromValue(autoFill: IAutoFill): autoFill is IAutoFillFromValue {
  return autoFill.type === 'value'
}

interface IAutoFillFromQueryParam {
  type: 'queryParam'
  queryParameterName: string
}

export function isAutoFillFromQueryParam(autoFill: IAutoFill): autoFill is IAutoFillFromQueryParam {
  return autoFill.type === 'queryParam'
}

interface IAutoFillFromCookie {
  type: 'cookie'
  cookieName: string
}

export function isAutoFillFromCookie(autoFill: IAutoFill): autoFill is IAutoFillFromCookie {
  return autoFill.type === 'cookie'
}
